/**
 * AP-18 6. — die **Bereiche** des Assistenten.
 *
 * Ein Bereich verbindet drei Dinge, die sonst auseinanderliefen: die Seiten, auf denen der
 * Benutzer steht (Oberfläche), die Werkzeuge, die dort vorne stehen (Backend), und was ein Mandant
 * vom Assistenten ausschließen kann (AS-17). Deshalb steht die Liste hier und nicht in einer der
 * beiden Apps.
 *
 * Kein Klartext: Wie ein Bereich heißt, sagt die Oberfläche (`assistant.areas.<key>`).
 */
export const ASSISTENT_BEREICHE = [
  // Werkzeuge ohne Fachmodul (Hilfe, Verweise) — keine eigene Seite, nicht ausschließbar.
  { key: 'general', pfade: [] },
  { key: 'time', pfade: ['/time-tracking', '/mitarbeiter-app'] },
  { key: 'crm', pfade: ['/clients'] },
  { key: 'articles', pfade: ['/articles'] },
  { key: 'projects', pfade: ['/projects', '/project-management', '/project-tasks', '/work-cockpit', '/material-certificates', '/purchasing', '/project-billing'] },
  { key: 'calculation', pfade: ['/calculations'] },
  { key: 'correspondence', pfade: ['/correspondence'] },
  { key: 'incoming_invoices', pfade: ['/incoming-invoices'] },
  { key: 'inbox', pfade: ['/inbox'] },
  { key: 'payroll', pfade: ['/payroll'] },
  { key: 'settings', pfade: ['/settings', '/users', '/integration'] },
] as const

export type AssistentBereich = (typeof ASSISTENT_BEREICHE)[number]['key']

/**
 * AP-18 5.3 — der Ordner des Handbuchs (`docs/Hilfe/<ordner>/`) zu einem Bereich: Aus seinen
 * freigegebenen Themen kommen die Beispielfragen eines Dashboards. Ein Ordner, den es noch nicht gibt,
 * liefert nichts — die Namen stehen hier, wie die Spezifikationen sie vorsehen (AP-18 8.2, AP-39 21.).
 */
export const ASSISTENT_HILFE_ORDNER: Partial<Record<AssistentBereich, string>> = {
  time: 'zeiterfassung',
  correspondence: 'schriftverkehr',
  projects: 'projekte',
  calculation: 'kalkulation',
  inbox: 'posteingang',
}

export const ASSISTENT_BEREICH_ALLGEMEIN: AssistentBereich = 'general'

/** Der Bereich einer Seite — der längste passende Pfad gewinnt; `undefined` auf Seiten ohne Bereich (Dashboard, Profil). */
export function assistentBereichFuerPfad(pathname: string): AssistentBereich | undefined {
  let treffer: { key: AssistentBereich; laenge: number } | undefined
  for (const b of ASSISTENT_BEREICHE) {
    for (const p of b.pfade) {
      if ((pathname === p || pathname.startsWith(`${p}/`)) && p.length > (treffer?.laenge ?? 0)) treffer = { key: b.key, laenge: p.length }
    }
  }
  return treffer?.key
}

export function istAssistentBereich(wert: string): wert is AssistentBereich {
  return ASSISTENT_BEREICHE.some((b) => b.key === wert)
}
